import { useAuthContext } from 'src/auth/hooks';
import { Permission } from 'src/assets/data/permissions';

/**
 * Returns true if the current user holds at least one of the given permissions.
 * Reads directly from the JWT profile — no API call is made.
 *
 * Usage with RTK Query skip:
 *   const canRead = useHasPermission(Permission.ReadClient);
 *   useGetClientsQuery(args, { skip: !canRead });
 */
export function useHasPermission(permission: Permission | Permission[]): boolean {
  const { user } = useAuthContext();
  const userPermissions: string[] = user?.profile?.permissions ?? [];

  if (Array.isArray(permission)) {
    return permission.some((p) => userPermissions.includes(p));
  }

  return userPermissions.includes(permission);
}
